"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymetricPaymentType = exports.PaymentTypeCode = exports.OnboardingPaymentMethod = exports.PaymentMethod = void 0;
var PaymentMethod;

(function (PaymentMethod) {
  PaymentMethod["EC"] = "eCheck";
  PaymentMethod["CC"] = "Credit Card";
  PaymentMethod["PT"] = "Payment Terms";
  PaymentMethod["PP"] = "Paypal";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));

var OnboardingPaymentMethod;

(function (OnboardingPaymentMethod) {
  OnboardingPaymentMethod["CC"] = "Credit Card";
  OnboardingPaymentMethod["CACD"] = "Cash in Advance/Cash On Delivery";
  OnboardingPaymentMethod["PT"] = "Terms";
})(OnboardingPaymentMethod || (exports.OnboardingPaymentMethod = OnboardingPaymentMethod = {}));

var PaymentTypeCode;

(function (PaymentTypeCode) {
  PaymentTypeCode["Checking"] = "1";
  PaymentTypeCode["Savings"] = "2";
  PaymentTypeCode["Corporate"] = "3";
  PaymentTypeCode["CorporateSavings"] = "4";
  PaymentTypeCode["AmericanExpress"] = "AX";
  PaymentTypeCode["Discover"] = "DI";
  PaymentTypeCode["MasterCard"] = "MC";
  PaymentTypeCode["Visa"] = "VI";
  PaymentTypeCode["PaymentTerms"] = "PT";
  PaymentTypeCode["Paypal"] = "PP";
})(PaymentTypeCode || (exports.PaymentTypeCode = PaymentTypeCode = {}));

var PaymetricPaymentType;

(function (PaymetricPaymentType) {
  PaymetricPaymentType["CreditCard"] = "creditCard";
  PaymetricPaymentType["BankAccount"] = "bankAccount";
})(PaymetricPaymentType || (exports.PaymetricPaymentType = PaymetricPaymentType = {}));